import { CouncilParticipant, SocietyDirector } from 'types';

export const getDirectorsFromParticipants = (
  participants: CouncilParticipant[] | undefined,
  directors: SocietyDirector[] | undefined
): SocietyDirector[] => {
  if (!participants || !directors) {
    return [];
  }

  return directors.filter((director) =>
    participants.some((participant) => participant.member === director._id)
  );
};
